import apiClient from './apiClient';

export const login = (credentials) => apiClient.post("/login", credentials);
